var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var breathe = require('../utils/breathe'); //Returns the GPS data as an object for geojson


function getGPGS5Data(_x) {
  return _getGPGS5Data.apply(this, arguments);
} //Converts the processed data to geojson


function _getGPGS5Data() {
  _getGPGS5Data = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var properties, coordinates, key, stream, i, s;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            properties = {};
            coordinates = [];
            _context2.t0 = _regeneratorRuntime.keys(data);

          case 3:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 22;
              break;
            }

            key = _context2.t1.value;
            //Save device name
            if (data[key]['device name'] != null) properties.device = data[key]['device name'];

            if (!data[key].streams) {
              _context2.next = 20;
              break;
            }

            _context2.t2 = _regeneratorRuntime.keys(data[key].streams);

          case 8:
            if ((_context2.t3 = _context2.t2()).done) {
              _context2.next = 20;
              break;
            }

            stream = _context2.t3.value;
            _context2.next = 12;
            return breathe();

          case 12:
            if (!(stream === 'GPS5' && data[key].streams.GPS5.samples && data[key].streams.GPS5.samples.length)) {
              _context2.next = 18;
              break;
            }

            //Save altitude offset
            if (data[key].streams.GPS5.samples[0].sticky && data[key].streams.GPS5.samples[0].sticky.geoidHeight) {
              properties.geoidHeight = data[key].streams.GPS5.samples[0].sticky.geoidHeight;
            } //Will save utc and cts


            properties.AbsoluteUtcMicroSec = [];
            properties.RelativeMicroSec = []; //Loop all the samples

            for (i = 0; i < data[key].streams.GPS5.samples.length; i++) {
              s = data[key].streams.GPS5.samples[i]; //Check that at least we have the valid values

              if (s.value && s.value.length > 1) {
                coordinates[i] = [s.value[1], s.value[0]]; //Set elevation if present

                if (s.value.length > 1) coordinates[i].push(s.value[2]); //Set time if present

                if (s.date != null) {
                  if (typeof s.date != 'object') s.date = new Date(s.date);
                  properties.AbsoluteUtcMicroSec[i] = s.date.getTime();
                }

                if (s.cts != null) properties.RelativeMicroSec[i] = s.cts;
              }
            }

            return _context2.abrupt("return", {
              coordinates: coordinates,
              properties: properties
            });

          case 18:
            _context2.next = 8;
            break;

          case 20:
            _context2.next = 3;
            break;

          case 22:
            return _context2.abrupt("return", {
              coordinates: coordinates,
              properties: properties
            });

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getGPGS5Data.apply(this, arguments);
}

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
    var name, converted, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = _ref.name;
            _context.next = 3;
            return getGPGS5Data(data);

          case 3:
            converted = _context.sent;
            result = {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: converted.coordinates
              },
              properties: _objectSpread({
                name: name
              }, converted.properties)
            };
            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();